import { graphql } from "../gql";
import { useQuery } from "@apollo/client";

const GetOneOnOnePlanPurchasesQuery = graphql(`
  query getOneOnOnePlanPurchases($onboardingFormCompleted: Boolean) {
    getOneOnOnePlanPurchases(
      onboardingFormCompleted: $onboardingFormCompleted
    ) {
      orderId
      purchasedAt
      userEmail
      onboardingFormCompleted
      hasActiveGroupPlan
      lastGroupPlanEndDate
    }
  }
`);

export function useGetOneOnOnePlanPurchases({
  onboardingFormCompleted,
}: {
  onboardingFormCompleted?: boolean;
}) {
  const { data, loading } = useQuery(GetOneOnOnePlanPurchasesQuery, {
    variables: { onboardingFormCompleted },
    fetchPolicy: "cache-and-network",
  });

  return {
    purchases: data?.getOneOnOnePlanPurchases ?? [],
    loading,
  };
}
